import { Button, Flex } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { PlusOutlined } from "@ant-design/icons";
import { AxiosError } from "axios";
import { HrmStationeryTable } from "../../components/hrm/HrmStationeryTable";
import { ModalAddStationery } from "../../components/modal/hrm/ModalAddStationery";

import ProductIcon from "../../components/icons/ProductIcon";
import { IQueryStationeryPeriod, IStationeryPeriod } from "../../models/Hrm";
import {
  useGetAllStationeryPeriods,
  useReviewStationeryPeriod,
} from "../../query/HrmQuery";
import { notify } from "../../utils/toast";

const HrmStationeryPeriod = () => {
  const navigate = useNavigate();

  const [filter, setFilter] = useState<IQueryStationeryPeriod>({
    page: 1,
    limit: 10,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [editingPeriod, setEditingPeriod] = useState<IStationeryPeriod | null>(
    null,
  );
  const { data, isLoading } = useGetAllStationeryPeriods(filter);
  const reviewMutation = useReviewStationeryPeriod();
  const handleReview = async (id: number, isApprove: boolean) => {
    try {
      await reviewMutation.mutateAsync({ id, isApprove });
      notify.success("Cập nhật trạng thái thành công");
    } catch (error: unknown) {
      const err = error as AxiosError<{ message: string }>;

      notify.error(
        err.response?.data?.message || "Cập nhật trạng thái thất bại",
      );
    }
  };

  return (
    <div className="flex-1  p-4 overflow-auto h-full">
      <Flex vertical gap="large" className="w-full">
        <Flex align="center" justify="end" gap="small" wrap="wrap">
          <Button
            variant="solid"
            color="geekblue"
            icon={<ProductIcon />}
            onClick={() => navigate("/hrm/stationerys/products")}
          >
            Vật phẩm
          </Button>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingPeriod(null);
              setIsOpen(true);
            }}
          >
            Tạo mới
          </Button>
        </Flex>
        <HrmStationeryTable
          data={data?.data}
          isLoading={isLoading}
          filter={filter}
          setFilter={setFilter}
          isHrmView={true}
          onReview={handleReview}
          onEdit={(record) => {
            setEditingPeriod(record);
            setIsOpen(true);
          }}
        />
      </Flex>
      <ModalAddStationery
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        initialData={editingPeriod}
      />
    </div>
  );
};

export default HrmStationeryPeriod;
